import palette from './palette'

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 32,
    letterSpacing: '-0.24px',
    // lineHeight: '40px'
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 27,
    letterSpacing: '-0.24px',
    // lineHeight: '32px'
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 22,
    letterSpacing: '-0.06px',
    // lineHeight: '28px'
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.06px',
    // lineHeight: '24px'
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
    // lineHeight: '20px'
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 12,
    letterSpacing: '-0.05px',
    // lineHeight: '20px'
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: 15,
    letterSpacing: '-0.05px',
    // lineHeight: '25px'
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: 13,
    letterSpacing: '-0.05px',
    // lineHeight: '21px'
  },
  body1: {
    color: palette.text.primary,
    fontSize: 12,
    letterSpacing: '-0.05px',
    // lineHeight: '21px'
  },
  body2: {
    color: palette.text.secondary,
    fontSize: 11,
    letterSpacing: '-0.04px',
    // lineHeight: '18px'
  },
  body3: {
    color: palette.text.secondary,
    fontSize: '14px',
    letterSpacing: '-0.04px',
    // lineHeight: '18px'
  },
  button: {
    color: palette.text.primary,
    fontSize: 12
  },
  caption: {
    color: palette.text.secondary,
    fontSize: 10,
    letterSpacing: '-0.04px',
    lineHeight: '1px'
  },
  overline: {
    color: palette.text.secondary,
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase'
  }
}
